import { getQueryVariable } from "tpm-utils";
/**
 * prime products page tabs
 */
$(self).ready(() => {
	const tpm_tabs = document.querySelectorAll(".js_tpm-tab");
	if (tpm_tabs.length) {
		const tpmClickTab = function (tab) {
			document
				.querySelectorAll(".js_tpm-tab-target, .js_tpm-tab")
				.forEach((el) => {
					el.classList.remove("--active");
				});
			document
				.querySelectorAll("." + tab.getAttribute("data-target"))
				.forEach((el) => {
					el.classList.add("--active");
				});
			tab.classList.add("--active");
			if (window.innerWidth < 577) {
				window.scrollTo(0, 0);
			}
			tpmUpdateHistory(tab.getAttribute("data-target"));
		};

		const tpmUpdateHistory = function (tabName) {
			history.pushState(
				{},
				null,
				`${window.location.protocol}//${document.location.hostname}${document.location.pathname}?tab=${tabName}`
			);
		};

		$.urlParam = function (name) {
			var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
				window.location.href
			);
			if (results) return results[1];
			return null;
		};

		const tpmActiveTab = document.querySelector(
			`.js_tpm-tab[data-target=${$.urlParam("tab")}]`
		);
		if (tpmActiveTab) tpmClickTab(tpmActiveTab);

		tpm_tabs.forEach((tab) => {
			tab.addEventListener("click", (e) => {
				tpmClickTab(tab);
			});
		});
	}

	/**
	 * prime products page plan swapping
	 */
	if ($(".js_swap-plan").length) {
		$(".js_swap-plan").click(function () {
			const tar = "." + $(this).data("target");
			$(tar + " .yearly, " + tar + " .monthly").toggleClass("active");
			//adding this line makes this func work for page-prime-products-2 as well
			$(tar + ".yearly, " + tar + ".monthly").toggleClass("active");

			//Toggle stuff
			$(tar + ".Toggle").toggleClass("active");
		});

		if (getQueryVariable("default") === "monthly") {
			$(".js_swap-plan").click();
		}
	}

	/**
	 * prime products page show more btn
	 */
	if ($(".js_prime-features-more").length) {
		$(".js_prime-features-more").click(function () {
			$(this).addClass("hidden");
			$(this).next().removeClass("hidden");
			$("." + $(this).data("target")).toggleClass("--visible");
		});
	}
});
